import { analysisOneDimTableBuilder } from './BAnalysisOneDimTable'

export const BAnalysisLineBarTable = analysisOneDimTableBuilder('BAnalysisLineBarTable')
